module.exports = __webpack_public_path__ + "img/fleischtaschen.72340049.jpg";